var map = {
	"./taksa_1.png": 4712,
	"./taksa_2.png": 1050,
	"./taksa_3.png": 6551,
	"./taksa_4.png": 48,
	"./taksa_5.png": 2545,
	"./taksa_6.png": 3719,
	"./taksa_7.png": 5612,
	"./taksa_8.png": 5061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2090;